<template>
  <v-container grid-list-sm fluid class="pa-0">
    <v-layout row wrap>
      <v-card style="width: 360px;" class="max-shadow">
        <v-card-title>
          <div class="title-2">Admin</div>
        </v-card-title>
        <v-divider />
        <v-list dense class="pa-3">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="subheading">{{ tenant.admin.name }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="subheading">{{ tenant.admin.phone }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>email</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="subheading">{{ tenant.admin.email }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
      <moduleSettings :tenantId="tenantId" />
    </v-layout>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';
import ModuleSettings from './ModuleSettings';

export default {
  name: 'Company',
  components: {
    moduleSettings: ModuleSettings
  },
  props: {
    tenantId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tenant: {
        admin: {}
      }
    };
  },
  mounted() {
    // fetch tenant details
    firestore
      .collection('tenants')
      .doc(this.tenantId)
      .get()
      .then(tenantSnapshot => {
        this.tenant = tenantSnapshot.data();
      });
  }
};
</script>
